<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VRkoJv/tc-custom/9781476708140.jpg?1730527315933" alt="This image is the cover for the book Best American Poetry 2013, The Best American Poetry Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best American Poetry 2013, The Best American Poetry Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Beloved and inventive poet Denise Duhamel </b><b><b>selects the poems for </b></b><b><b>the 2013 edition of <i>The Best American Poetry</i>,</b><b>“a ‘best’ anthology that really lives up to its title” (<i>Chicago Tribune).</i></b></b><br/><br/>Over the last twenty-five years, the <i>Best American Poetry</i> series has become an annual rite of autumn, eagerly awaited and hotly debated: “an essential purchase” (<i>The Washington Post</i>). This year, guest editor Denise Duhamel brings her wit and enthusiasm and her commitment to poetry in all its wide variety to bear on her choices for <i>The Best American Poetry 2013</i>. These acts of imagination—from known stars and exciting newcomers—testify to the vitality of an art form that continues to endure and flourish, defying dour predictions of its demise, in the digital age.<br/><br/>This edition of the most important poetry anthology in the United States opens with David Lehman’s incisive “state of the art” essay and Denise Duhamel’s engagingly candid discussion of the seventy-five poems that made her final cut. Reflecting the vibrant state of our country’s contemporary poetry scene, <i>The Best American Poetry 2013</i> includes such eminences as John Ashbery, Louise Gluck, James Tate, and Richard Wilbur, as well as the fast-rising hot poets Sherman Alexie, Nin Andrews, Anna Maria Hong, Timothy Donnelly, Mary Ruefle, and Major Jackson.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Denise Duhamel, David Lehman
      </h2>
      
      <p class="authorDescription body article">David Lehman, the series editor of&#160;<I>The Best American Poetry</I>, edited&#160;<I>The&#160;Oxford Book of American Poetry</I>. His books of poetry include&#160;<I>The Morning Line</I>,&#160;<I>When a Woman Loves a Man</I>,&#160;and&#160;<I>The Daily Mirror.</I>&#160;The most recent of his many nonfiction books is&#160;<I>The Mysterious Romance of Murder: Crime, Detection, and the Spirit of Noir</I>. He lives in New York City and Ithaca, New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scribner
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d5a12ba0